module.exports = __webpack_public_path__ + "static/media/paste-icon.82a3741d.svg";